import React from 'react';
import './LoadingPage.css';

function LoadingPage() {
  return (
    <div className="loading-page">
      <h1>Earth explorer</h1>
      <div className="spinner"></div>
    </div>
  );
}

export default LoadingPage;